import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Button } from './Button';

type SecondaryButtonVariant = 'default' | 'outlined' | 'outlined-error';
const variantStyles: Record<SecondaryButtonVariant, string> = {
  default: classNames(
    'bg-secondary-600 text-white',
    'disabled:bg-secondary-100',
    'disabled:text-secondary-400',
    'hover:shadow-down-sm',
    'hover:bg-secondary-500',
  ),
  outlined: classNames(
    'bg-white text-secondary-600',
    'border border-secondary-300',
    'disabled:border-secondary-200',
    'disabled:text-secondary-400',
    'hover:shadow-down-sm',
    'hover:bg-secondary-50',
  ),
  "outlined-error": classNames(
    'bg-white text-red-500',
    'border border-red-300',
    'disabled:border-secondary-200',
    'disabled:text-secondary-400',
    'hover:shadow-down-sm',
    'hover:bg-secondary-50',
  ),
};

export type SecondaryButtonProps = {
  variant?: SecondaryButtonVariant;
} & ComponentProps<typeof Button>;

export const SecondaryButton = ({
  className,
  variant,
  ...props
}: SecondaryButtonProps) => {
  const style = variantStyles[variant ?? 'default'];
  return (
  <Button
    className={classNames(
      'disabled:cursor-not-allowed',
      'text-body-1-xl font-semibold',
      'transition ease-in',
      'justify-center items-center',
      'relative',
      'rounded-full',
      'py-2 px-4',
      style,
      className
    )}
    type="submit"
    {...props}
  />
)};
